import { GetAuthToken } from '@domain/auth/AuthContext';

import { get } from './shared';

export const getZendeskToken = async (getAuthToken: GetAuthToken): Promise<string> => {
  const response = await get('/external/zendesk/token', getAuthToken);
  const token = await response.text();
  return token;
};
